<template>
  <div class="page-content-wrapper home">
    <welcome></welcome>
  </div>
</template>

<script>
  import Welcome from './Welcome.vue'

  export default {
    name: 'home',


    data () {
      return {
        auth: this.$store.state.auth
      }
    },


    components: {
      Welcome
    }
  }
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/screens/HomeScreen.vue